import { isDevMode } from "@angular/core";

const LOOKUP = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
const TESTING_CARDS = [
  // Braspag gateway test cards
  "0000000000000001", // Success
  "0000000000000002", // Unauthorized
  "0000000000000009", // Random return
  "0000000000000007", // Canceled credit card
  "0000000000000008", // Credit card issues
  "0000000000000005", // Blocked credit card
  "0000000000000003", // Expired credit card
  "0000000000000006", // Time out

  // Cielo 3DS test cards — with challenge
  "4000000000002503", // Visa — 3DS success (challenge + authenticated)
  "5200000000002151", // Master — 3DS success (challenge + authenticated)
  "6505290000002190", // Elo — 3DS success (challenge + authenticated)
  "4000000000002370", // Visa — 3DS failure (challenge + failed)
  "5200000000002490", // Master — 3DS failure (challenge + failed)
  "6505290000002208", // Elo — 3DS failure (challenge + failed)
  "4000000000002420", // Visa — 3DS unenrolled
  "5200000000002664", // Master — 3DS unenrolled
  "6505290000002257", // Elo — 3DS unenrolled
  "4000000000002644", // Visa — 3DS error
  "5200000000002656", // Master — 3DS error
  "6505290000002265", // Elo — 3DS error

  // Cielo 3DS test cards — frictionless (no challenge)
  "4000000000002701", // Visa — 3DS frictionless success
  "5200000000002235", // Master — 3DS frictionless success
  "6505290000002000", // Elo — 3DS frictionless success
  "4000000000002925", // Visa — 3DS frictionless failure
  "5200000000002276", // Master — 3DS frictionless failure
  "6505290000002018", // Elo — 3DS frictionless failure

  // Cielo 3DS test cards — data only
  "5200000000002805", // Master — 3DS data only
  "4000000000002024", // Visa — 3DS data only
];

export const luhnCheck = (input: string): boolean => {
  const digits = input.replace(/\D/g, "");

  if (isDevMode() && TESTING_CARDS.includes(digits)) return true;

  if (!digits) return false;

  let sum = 0;
  let shouldDouble = false;

  for (let i = digits.length - 1; i >= 0; i--) {
    const digit = Number(digits[i]);
    sum += shouldDouble ? LOOKUP[digit] : digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};
